<template>
    <div>
        <div
            v-if="isInCart"
            class="cabinet__catalog-form d-flex align-items-center w-100 mt-0"
        >
            <button
                class="cabinet__catalog-form_minus"
                @click="decreaseQuantityInCart"
            />
            <input
                type="text"
                class="cabinet__catalog-form_input cabinet-form-group__input"
                :value="inCartQuantity"
                @change="onInCartQuantityInput"
            />
            <button
                class="cabinet__catalog-form_plus"
                @click="increaseQuantityInCart"
            />
            <button
                v-if="false"
                type="button"
                class="cabinet__catalog-form_remove ml-auto"
                title="Удалить из корзины"
                @click="removeProductFromCart"
            />
        </div>
        <button
            v-else
            class="cabinet-btn v2-retailer-order__brand-product-cart-btn"
            @click="addProductToCart"
        >
            В корзину
        </button>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import checkDemoUser from '@/mixins/checkDemoUser.js'

export default {
    name: 'AddToCart',
    mixins: [checkDemoUser],
    props: {
        product: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            inCartQuantity: 0,
            cartLoader: false
        }
    },
    computed: {
        ...mapGetters('cart', ['productInCart']),
        productID() {
            return this.product.ItemID
        },
        isInCart() {
            return !!this.productInCart(this.productID)
        },
        cartProduct() {
            return this.productInCart(this.productID)
        }
    },
    mounted() {
        this.inCartQuantity = this.productInCart(this.productID)
            ? this.productInCart(this.productID).pivot.Quantity
            : 0
    },
    methods: {
        ...mapActions('cart', [
            'getCart',
            'addToCart',
            'deleteFromCart',
            'changeItemQuantity'
        ]),
        addProductToCart() {
            if (this.isDemoUserMode()) return

            this.cartLoader = true

            this.addToCart(this.productID)
                .then(() => {
                    this.getCart()
                    this.inCartQuantity = 1
                })
                .finally(() => {
                    this.cartLoader = false
                })
        },
        removeProductFromCart() {
            this.cartLoader = true

            this.deleteFromCart(this.productID)
                .then(() => {
                    this.getCart()
                    this.inCartQuantity = 0
                })
                .finally(() => {
                    this.cartLoader = false
                })
        },
        increaseQuantityInCart() {
            this.inCartQuantity++
            this.changeQuantityInCart()
        },
        decreaseQuantityInCart() {
            if (this.inCartQuantity > 1) {
                this.inCartQuantity--
                this.changeQuantityInCart()
            } else {
                this.removeProductFromCart()
            }
        },
        onInCartQuantityInput(e) {
            let val = e.target.value
            this.inCartQuantity = parseInt(val.replace(/\D/g, '') || 0)
            e.target.value = this.inCartQuantity
            if (this.inCartQuantity >= 1) {
                this.changeQuantityInCart()
            } else {
                this.removeProductFromCart()
            }
        },
        changeQuantityInCart() {
            if (this.quantityTimer) {
                clearInterval(this.quantityTimer)
            }

            this.quantityTimer = setTimeout(() => {
                this.changeItemQuantity({
                    productID: this.product.ItemID,
                    quantity: this.inCartQuantity,
                    comment: this.cartProduct.pivot.Comment
                })
            }, 1000)
        }
    }
}
</script>
